var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        title: "退款详情",
        visible: _vm.visible,
        "close-on-click-modal": false,
        width: "500px",
        top: "5vh",
        "append-to-body": "",
      },
      on: { close: _vm.onDialogClose },
    },
    [
      _c(
        "div",
        { staticClass: "detail-dialog-content" },
        [
          _c(
            "el-form",
            { attrs: { size: "small", "label-width": "90px" } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "订单编号: " } },
                [
                  _c("span", [_vm._v(_vm._s(_vm.refundDetail.outTradeNo))]),
                  _vm.refundDetail.outTradeNo
                    ? _c(
                        "el-button",
                        {
                          staticStyle: { "margin-left": "10px" },
                          attrs: { type: "text", size: "small" },
                          on: { click: _vm.viewOrder },
                        },
                        [_vm._v("查看订单")]
                      )
                    : _vm._e(),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "退款单号: " } }, [
                _c("span", [_vm._v(_vm._s(_vm.refundDetail.refundNum))]),
              ]),
              _c("el-form-item", { attrs: { label: "支付金额: " } }, [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.refundDetail.totalPayFee / 100 || "-") + "元"
                  ),
                ]),
              ]),
              _c("el-form-item", { attrs: { label: "退款方式: " } }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.refundDetail.refundFunText || "-")),
                ]),
              ]),
              _c("el-form-item", { attrs: { label: "退款金额: " } }, [
                _c("span", [
                  _vm._v(
                    _vm._s(_vm.refundDetail.refundAmount / 100 || "-") + "元"
                  ),
                ]),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "退款原因: " } },
                [
                  _c("el-input", {
                    attrs: {
                      value: _vm.refundDetail.refundReason,
                      disabled: "",
                      readonly: "",
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 4 },
                    },
                  }),
                ],
                1
              ),
              _c("el-form-item", { attrs: { label: "申请人: " } }, [
                _c("span", [_vm._v(_vm._s(_vm.refundDetail.refundApplyUser))]),
              ]),
              _c("el-form-item", { attrs: { label: "申请时间: " } }, [
                _c("span", [_vm._v(_vm._s(_vm.refundDetail.createTime))]),
              ]),
              _c("el-form-item", { attrs: { label: "退款状态: " } }, [
                _c("span", [_vm._v(_vm._s(_vm.refundDetail.refundStatusText))]),
              ]),
              _c("el-form-item", { attrs: { label: "处理人: " } }, [
                _c("span", [_vm._v(_vm._s(_vm.refundDetail.refundHandleUser))]),
              ]),
              _c("el-form-item", { attrs: { label: "处理时间: " } }, [
                _c("span", [_vm._v(_vm._s(_vm.refundDetail.handleTime))]),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "处理意见: " } },
                [
                  _c("el-input", {
                    attrs: {
                      value: _vm.refundDetail.mark,
                      disabled: "",
                      readonly: "",
                      type: "textarea",
                      autosize: { minRows: 2, maxRows: 4 },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }